import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#114A4E",
      d: "m20 11.996-1.774-1.992.247-2.637-2.626-.588L14.473 4.5 12 5.546 9.527 4.5 8.153 6.779l-2.626.58.248 2.638-1.775 2 1.775 1.992-.248 2.644 2.626.588L9.527 19.5 12 18.447l2.473 1.046 1.374-2.28 2.626-.587-.247-2.637zm-9.454 3.584-2.91-2.867 1.026-1.01 1.883 1.849 4.793-4.723 1.026 1.017z"
    }, null, -1)
  ])))
}
export default { render: render }